import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyRemoteRequests, getRemoteDaysBalance } from "../../slices/remoteRequest";
import FormRemoteRequest from "./FormRemoteRequest";
import getAccess from "../../utilities/getAccess";
import SubTitle from "../../components/SubTitle/SubTitle.jsx";
import "./_remoteRequest.scss";

const RemoteRequest = (props) => {
  const {
    id,
    handleClose,
    row,
    remoteRequestDetails,
    updateMyRemoteRequest,
    disabled,
  } = props;

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.fetchMe);
  const [notice, setNotice] = useState({ open: false, text: "", state: "" });

  const { 
    myRemoteRequests, 
    remoteDaysBalance,
    getMyRemoteRequestsStatus,
  } = useSelector((state) => state.remoteRequest);

  useEffect(() => {
    if (
      getAccess(
        user?.permissions,
        user?.permissionGroups?.[0]?.permissions,
        "REMOTE REQUEST",
        "LIST"
      )
    ) {
      dispatch(getMyRemoteRequests());
      dispatch(getRemoteDaysBalance());
    }
  }, [user, dispatch]);

  const hasRemoteRequestListPermission = getAccess(
    user?.permissions,
    user?.permissionGroups?.[0]?.permissions,
    "REMOTE REQUEST",
    "LIST"
  );

  const hasRemoteRequestCreatePermission = getAccess(
    user?.permissions,
    user?.permissionGroups?.[0]?.permissions,
    "REMOTE REQUEST",
    "CREATE"
  );

  return (
    <div className="big-wrapper-apply-for-leave">
      <div className="left-child-wrraper">
        <FormRemoteRequest
          handleClose={handleClose}
          id={id}
          row={row}
          remoteRequestDetails={remoteRequestDetails}
          updateMyRemoteRequest={updateMyRemoteRequest}
          disabled={disabled}
          setNotice={setNotice}
        />
      </div>
    </div>
  );
};

export default RemoteRequest;